<div class="prix-vente-decoupage cursorHelp" *ngIf="display()" title="prix de vente total pour '{{cellule.libelleDecoupageRepas.toUpperCase()}}'" >
  <i class="fa-solid fa-euro-sign fa-xs mg-r-5"></i>{{cellule.prixVenteTotal | currency:'EUR':'symbol':'1.4-4'}}
</div>
